import { z } from "zod";
import { moneyField, optionalEmail, optionalText, optionalUuid, quantityField, } from "./common.js";
export const supplierSchema = z.object({
    code: z.string().trim().min(1, "Code is required.").max(16),
    name: z.string().trim().min(1, "Name is required.").max(160),
    contactName: optionalText(120),
    phone: optionalText(40),
    email: optionalEmail(),
    paymentNote: optionalText(500),
});
export const purchaseOrderLineSchema = z.object({
    materialId: optionalUuid(),
    jobOperationId: optionalUuid(),
    description: optionalText(300),
    quantity: quantityField,
    unitCost: moneyField,
});
export const purchaseOrderCreateSchema = z.object({
    supplierId: z.string().uuid("Invalid supplier id."),
    jobId: optionalUuid(),
    expectedDate: z.string().date().optional(),
    notes: optionalText(4000),
    lines: z.array(purchaseOrderLineSchema).min(1, "Add at least one line.").max(50),
});
export const receiveLineSchema = z.object({
    poLineId: z.string().uuid("Invalid line id."),
    quantity: quantityField,
    locationId: optionalUuid(),
});
export const receiveSchema = z.object({
    supplierReference: optionalText(120),
    lines: z.array(receiveLineSchema).min(1, "Add at least one line.").max(50),
});
export const supplierIdParamSchema = z.object({
    id: z.string().uuid("Invalid supplier id."),
});
export const purchaseOrderIdParamSchema = z.object({
    id: z.string().uuid("Invalid purchase order id."),
});
//# sourceMappingURL=purchasing.js.map